var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-cols-lg-2"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"d-block p-2 bg-mdh text-white"},[_vm._v(" Facility ")]),_c('b-col',[_vm._v(" "+_vm._s(_vm.selectedFacility)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }